module.exports = __webpack_public_path__ + "static/media/mdi_add_box.73f93829.svg";